import * as React from 'react';
import { OrderSummary } from '../../transportation/models/shared/order-summary';
import { toSlashedShortDate } from '../../utils/date-utils';
import { createSelectable, TSelectableItemProps } from '../drag-select';

interface IProps extends TSelectableItemProps {
    orderItem: OrderSummary;
}

export const FlyoutOrderControlRow = (props : IProps) => {

    const { selectableRef, 
        isSelected, 
        isSelecting, 
        orderItem
     } = props;

     let actualClass = 'order-selectable';
     actualClass += (orderItem.isChecked) ? ' highlight' : '';
     actualClass += (isSelecting) ? ' dragging' : '';
     actualClass += (isSelected) ? ' selected-already' : '';
        
    return orderItem 
            ? <tr key={orderItem.id} 
                ref={selectableRef} 
                className={ actualClass }>
                <td>
                    <input
                        type="checkbox"
                        checked={orderItem.isChecked}
                        onChange={() => { return; }}
                    />
                </td>
                <td>{ orderItem.id }</td>
                <td>{ orderItem.description }</td>
                <td>{ orderItem.jobName }</td>
                <td>{ orderItem.cutoffDate ? toSlashedShortDate(orderItem.cutoffDate) : '' }</td>
            </tr>
        : <tr/>;

};

export default createSelectable(FlyoutOrderControlRow);
